import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";

function StatusItem({ label, value }) {
  return (
    <div className="flex items-center justify-between py-2">
      <span className="text-gray-600 font-medium">{label}</span>

      {value ? (
        <span className="flex items-center gap-2 font-semibold">
          <CheckCircleFilled style={{ color: "#16a34a" }} />
          <span className="text-green-600">Yes</span>
        </span>
      ) : (
        <span className="flex items-center gap-2 font-semibold">
          <CloseCircleFilled style={{ color: "#dc2626" }} />
          <span className="text-red-500">No</span>
        </span>
      )}
    </div>
  );
}

export default function FoodTaxAndDiscountView({ data }) {
  const {
    isVatApplicable,
    isDiscountApplicable,
    isSupplementaryDutyApplicable,
    supplementaryDuty,
  } = data;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 my-6">

      {/* VAT & Discount */}
      <div className="border rounded-xl p-6">
        <h3 className="font-semibold mb-4">VAT & Discount</h3>

        <StatusItem label="VAT Applicable" value={isVatApplicable} />
        <StatusItem label="Discount Applicable" value={isDiscountApplicable} />
      </div>

      {/* Supplementary Duty */}
      <div className="border rounded-xl p-6">
        <h3 className="font-semibold mb-4">Supplementary Duty</h3>

        <StatusItem
          label="SD Applicable"
          value={isSupplementaryDutyApplicable}
        />

        <div className="flex items-center justify-between py-2">
          <span className="text-gray-600 font-medium">SD Amount</span>
          <span className="font-semibold">
            {isSupplementaryDutyApplicable ? `${supplementaryDuty}%` : "0%"}
          </span>
        </div>
      </div>

    </div>
  );
}